import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import _PostDemand from './_ShoppingCart.scss';

class ShoppingCart extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      number: 0
    };
  }

  componentDidMount() {
    if (this.props.shoppingCart && this.props.shoppingCart.length > 0) {
      this.setState({number: this.props.shoppingCart.length});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shoppingCart) {
      this.setState({number: nextProps.shoppingCart.length});
    }
  }

  render() {
    return (
      <div className='wrap-btn wrap-btn-post-demand'>
        <Link to='/user/my-shopping-cart' className='btn-post-demand'>
          <i className='fa fa-shopping-cart'/>
          <span className='post-demand-text'>Giỏ hàng <span className='count-item'>({this.state.number})</span></span>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    shoppingCart: state.shoppingCart.items
  };
};

export default connect(mapStateToProps)(ShoppingCart);



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/ShoppingCart.jsx